// What we build (docs/13 "Products"): three commercial products from the OCS platform, and the
// tools we give away. Statuses say plainly what exists today.
import type { Icon } from "@phosphor-icons/react";
import { Cloud, DeviceMobile, Key, TreeStructure } from "@phosphor-icons/react";

import type { Interest } from "../api/types";

export interface Product {
  id: string;
  name: string;
  codename?: string;
  Icon: Icon;
  tagline: string;
  body: string;
  status: string;
  features: string[];
  interest: Interest;
}

export const PRODUCTS: Product[] = [
  {
    id: "workflows",
    name: "OCS Workflows",
    Icon: TreeStructure,
    tagline: "Automate the work. Keep the say.",
    body: "Turn the work your teams repeat into workflows: agent steps, guards that skip what doesn't need doing, and approvals where a person must decide. Tasks arrive from Jira or GitHub, run in isolation, and report back with what they cost.",
    status: "In daily use · early access",
    features: [
      "Branching workflows with loops, limits and versions you pin",
      "Approvals and questions answered from your phone",
      "Pre-execution guards: no task, no tokens",
      "Cost per step, task, team and person",
      "Parent tasks that plan and run their sub-tasks",
      "Publish to, and install from, the marketplace",
    ],
    interest: "workflows",
  },
  {
    id: "broker",
    name: "OCS Broker",
    codename: "Keymaker",
    Icon: Key,
    tagline: "Agents do the work. You keep the keys.",
    body: "A broker for any AI agent: it holds your credentials, makes each call on the agent's behalf inside the policy you wrote, waits for your approval on the dangerous ones, and keeps a record of every use. The agent never sees a key.",
    status: "In development · early-access list",
    features: [
      "No secrets in the agent, ever",
      "Short-lived, signed permission per run",
      "Policies by action and Danger Scale level",
      "Approvals signed on your own device",
      "An audit trail of every call",
    ],
    interest: "broker",
  },
  {
    id: "cloud",
    name: "OCS Cloud",
    Icon: Cloud,
    tagline: "A private agent cloud, on hardware you control.",
    body: "Agents run as disposable workers in environments of their own: a VM or a hardened container, its own network, its own Docker, egress you allow, a VPN where you need one. Conversations are encrypted to your devices before they leave the worker.",
    status: "Running in production · by arrangement",
    features: [
      "Isolated environment per team or task group",
      "Egress allow-lists and per-environment VPN",
      "End-to-end encrypted agent conversations",
      "Resource limits per role",
    ],
    interest: "cloud",
  },
];

export const COMPANION = {
  name: "OCS for iPhone and Android",
  Icon: DeviceMobile,
  body: "Answer an agent's questions, approve its next step and read its work, encrypted end to end, from wherever you are. Comes with OCS Workflows.",
};
